import { Fraga } from "@/types/riskbedomning";

export const elsakerhetFragor: Fraga[] = [
  {
    id: "loto-frankoppling",
    text: "Finns risker med säker frånkoppling (LOTO) vid arbete på eller nära elektriska installationer?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att rutiner för Lockout/Tagout (LOTO) saknas eller inte följs?",
      "Finns det risk att spänningslöst tillstånd inte verifieras innan arbete påbörjas?",
      "Finns det risk att obehöriga kan återkoppla strömmen under pågående arbete?",
      "Finns det risk att behörighetskrav för arbete på elanläggningar inte uppfylls (ESA)?",
      "Finns det risk att arbetsplatsen inte är tydligt märkt med varningsskyltar under frånkoppling?"
    ],
    afsReferences: ["AFS 2023:11", "ELSÄK-FS 2022:1"]
  },
  {
    id: "elverktyg-mobil-utrustning",
    text: "Finns risker med elverktyg och mobil elutrustning på byggarbetsplatsen?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att elverktyg med defekta kablar, stickkontakter eller kåpor används?",
      "Finns det risk att jordfelsskydd (RCD 30mA) saknas vid användning av bärbara elverktyg?",
      "Finns det risk att elverktyg används i våta eller fuktiga miljöer utan skyddsklass (minst IP44)?",
      "Finns det risk att periodisk besiktning av bärbar elutrustning inte genomförs?",
      "Finns det risk att personal saknar kunskap om elsäker hantering av verktyg?"
    ],
    afsReferences: ["AFS 2023:11"]
  },
  {
    id: "ensamarbete",
    text: "Finns risker med ensamarbete på byggarbetsplatsen?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att arbetstagare utför riskfyllt arbete utan tillgång till snabb hjälp?",
      "Finns det risk att kommunikationsmöjligheter saknas vid ensamarbete (telefon, larm)?",
      "Finns det risk att rutiner för incheckning eller tillsyn vid ensamarbete saknas?",
      "Finns det risk för hot eller våld vid ensamarbete, särskilt kvälls- eller nattetid?"
    ],
    afsReferences: ["AFS 2023:2"]
  },
  {
    id: "maskinsakerhet",
    text: "Finns risker med maskiner och motordriven utrustning på byggarbetsplatsen?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att skyddsanordningar på borrmaskiner, kapar eller sågmaskiner saknas eller är bortkopplade?",
      "Finns det risk att operatörer saknar utbildning eller behörighet för maskinerna?",
      "Finns det risk att daglig kontroll av maskiner och skyddsanordningar inte genomförs?",
      "Finns det risk att riskzoner runt maskiner inte är tydligt avgränsade?"
    ],
    afsReferences: ["AFS 2023:4"]
  },
  {
    id: "arbete-varme-kyla",
    text: "Finns risker med arbete i extrem värme eller kyla?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk för värmestress vid arbete i höga temperaturer utan tillgång till skugga och vatten?",
      "Finns det risk för kylskador eller hypotermi vid arbete utomhus vintertid?",
      "Finns det risk att arbets-/viloschema inte anpassas efter extrema temperaturförhållanden?",
      "Finns det risk att personlig skyddsutrustning inte är anpassad för klimatförhållandena?"
    ],
    afsReferences: ["AFS 2023:12"]
  }
];
